// extracted by mini-css-extract-plugin
module.exports = {"wrap":"e_ZS","button":"e__S","glyph":"e_0S","on":"e_1S","own":"e_2S","error":"e_3S","text":"e_4S"};